import React from "react";
import styled from "styled-components";

import { media } from "utils/style";
import { ENDPOINTS } from "utils/endpoints";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";
import StyledLink from "common-components/StyledLink";

const InactivityModal = ({ isLoggedOutModalOpen, isNonSecureUser, ...rest }) => {
  return (
    <Modal
      showTimeoutModal={isLoggedOutModalOpen}
      hideCloseButton
      contentLabel="you have been logged out modal"
    >
      <Div>
        <H2>{isNonSecureUser ? "Session ended" : "Logged Out"}</H2>
        <p style={{ marginBottom: "30px" }}>
          Due to inactivity, {isNonSecureUser ? "your session has ended" : "you have been logged out"}.
        </p>
        {isNonSecureUser ? (
          <Button onClick={(window.location = "/privacy/your-data")}>Renew session</Button>
        ) : (
          <StyledLink linkType="anchor" href={ENDPOINTS.LOGOUT}>
            Login
          </StyledLink>
        )}
      </Div>
    </Modal>
  );
};

export default InactivityModal;

const Div = styled.div`
  text-align: center;
  padding: 30px 75px;

  ${media.mobile`
    padding: 0;  
  `}
`;

const H2 = styled.h2`
  font-size: 24px;
  line-height: 26px;
  margin-bottom: 18px;
`;
